import { Input } from "@/components/ui/input"
import {
  formatUsdCanonical,
  normalizeMoneyCanonical,
  parseUsdInputRaw,
} from "@/lib/money-input"

/**
 * USD text field: live $ and thousands separators; value is a canonical
 * numeric string ("1234.56" or "") for forms and APIs.
 */
export function CurrencyUsdInput({
  id,
  value,
  onValueChange,
  className,
  placeholder,
  disabled,
  onBlur,
  ...rest
}) {
  const display = formatUsdCanonical(value)

  return (
    <Input
      {...rest}
      id={id}
      type="text"
      inputMode="decimal"
      autoComplete="off"
      className={className}
      placeholder={placeholder}
      disabled={disabled}
      value={display}
      onChange={(e) => {
        const next = parseUsdInputRaw(e.target.value)
        if (next !== undefined) onValueChange(next)
      }}
      onBlur={(e) => {
        onValueChange(normalizeMoneyCanonical(value))
        onBlur?.(e)
      }}
    />
  )
}
